
export class ExpensesModelDto{
    id:number
    head: string
    category: string
    month: number
    amount: number
    // createdUser: string | null
    // createdAt: Date
    // updatedAt: Date
    // updatedUser: string | null

    constructor(

        id:number,
        head: string,
        category: string,
        month: number,
        amount: number
    ){
this.id=id
this.head = head
this.category = category
this.month = month
this.amount = amount

    }
      
    }

    export class ExpensesModelDtoReq{
        data :ExpensesModelDto[]
        user:string
        constructor(
            data :ExpensesModelDto[],
        user:string
        ) {
            this.data = data
            this.user = user
        } }
